import Session from './Session';

const session = new Session();

export {
  session,
  Session
};
